"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
class AjaxCreator {
    constructor(configuration) {
        this.ajax = (newConfiguration = {}) => {
            const configuration = Object.assign(Object.assign({}, this.configuration), newConfiguration);
            const { version, baseURL = () => '', headers } = configuration;
            const newBaseUrl = baseURL(version !== null && version !== void 0 ? version : 'v1');
            if (newBaseUrl) {
                this.axiosInstance.defaults.baseURL = newBaseUrl;
            }
            if (headers) {
                this.axiosInstance.defaults.headers = Object.assign(Object.assign({}, this.axiosInstance.defaults.headers), headers);
            }
            return this.axiosInstance;
        };
        const { initialHeaders = {}, version, baseURL } = configuration, otherConfigurations = __rest(configuration, ["initialHeaders", "version", "baseURL"]);
        this.configuration = { initialHeaders, version, baseURL };
        this.axiosInstance = axios_1.default.create(Object.assign({ headers: Object.assign({}, initialHeaders) }, otherConfigurations));
    }
}
exports.default = AjaxCreator;
//# sourceMappingURL=index.js.map